exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".categoryImages{height:1.875em;margin:0 .625em 0 0;padding:0}", "", {"version":3,"sources":["/app/src/components/Elements/Sidebar/styles/Sidebar.css"],"names":[],"mappings":"AAAA,gBACE,eAAgB,AAChB,oBAA4B,AAC5B,SAAW,CACZ","file":"Sidebar.css","sourcesContent":[".categoryImages {\n  height: 1.875em;\n  margin: 0px 0.625em 0px 0px;\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Elements/Sidebar/styles/Sidebar.css
// module id = 1486
// module chunks = 0